/* LQP: Artikel aus Warenkorb (Seite + Snap-Drawer) auf die wbis-Wunschliste VERSCHIEBEN
 * + Warenkorb-Zeilen per AJAX entfernen + Snap-Rabattstufe aktuell halten.
 * Konfig kommt aus window.LQPWL (snippets/lqp-wishlist-move.liquid).
 *
 * 15.09.2026 (v2):
 * - Line-Item-Properties der Zeile (Armband-Builder-Konfiguration inkl. Schablone) gehen mit auf
 *   die Wunschliste (Feld "properties", JSON). "already_exists" loescht die Zeile NICHT mehr.
 * - Der Snap-Cart-Drawer haelt die Rabattstufe (10/15/20 %) in einem eigenen Zustand, den er nur
 *   nach AJAX-Warenkorb-Aenderungen (fetch/XHR auf /cart/*.js) nachzieht – ca. 4 s spaeter. Nach
 *   einer Seiten-Navigation (klassischer "Entfernen"-Link = /cart/change?id=…) blieb die ALTE,
 *   hoehere Stufe stehen und ging so in den Checkout ("Bestellrabatt zu hoch"). Deshalb:
 *   (a) Zeilen per /cart/change.js entfernen und vor dem Reload auf den Nachzug warten,
 *   (b) alle "Entfernen"-Links der Warenkorb-Seite auf denselben AJAX-Weg umbiegen,
 *   (c) beim Aufruf der Warenkorb-Seite die Stufe einmal "heilen" (Same-Quantity-Change =
 *       fuer Shopify ein No-op, loest aber Snaps Nachzug aus; bei Aenderung ein Reload).
 *   Ein veralteter Zeilen-Schluessel (Zeile wurde in einem anderen Tab/Flow ersetzt) fuehrt so
 *   nicht mehr auf Shopifys Fehlerseite "keine gueltigen ID- oder Zeilenparameter". */
(function () {
  var CFG = window.LQPWL || {};
  var API = CFG.api || '/apps/wishlist/api/wishlist';
  var WISHLIST_URL = CFG.wishlistUrl || '/apps/wishlist/account/wishlist';
  var CART_URL = CFG.cartUrl || '/cart';
  var JH = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  var HEART = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="flex-shrink:0"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>';

  // Mindestbestellwerte (EUR) der Snap-Rabattstufen 10/15/20 % – wie die Labels im Theme ("ab 19/59/99 €").
  // Nur eine Erwartung dafuer, WIE LANGE auf Snaps Nachzug gewartet wird (Stufe wechselt vermutlich -> laenger).
  var SNAP_TIERS = [19, 59, 99];

  // 28.09.2026: Texte je Shop-Sprache (<html lang>); Deutsch = unveraenderte Originaltexte (TX = null)
  var LANG = String(document.documentElement.getAttribute('lang') || 'de').slice(0, 2).toLowerCase();
  var TX = {
    en: { later: 'Save for later', laterTitle: 'Save to your wishlist for later', moved: ' was moved to your wishlist',
          movedCfg: ' was moved to your wishlist together with your design', exists: ' is already on your wishlist and stays in your cart.',
          view: 'View wishlist', item: 'Item', changedMoved: 'Added to your wishlist. Your cart changed in the meantime \u2013 please check it.',
          changedMovedShort: 'Added to your wishlist \u2013 your cart changed in the meantime.', failed: 'Sorry, that didn\u2019t work \u2013 please try again.',
          changed: 'Your cart changed in the meantime \u2013 please check it.' },
    fr: { later: 'Pour plus tard', laterTitle: 'Mettre de c\u00f4t\u00e9 dans votre liste d\u2019envies', moved: ' a \u00e9t\u00e9 d\u00e9plac\u00e9 dans votre liste d\u2019envies',
          movedCfg: ' a \u00e9t\u00e9 d\u00e9plac\u00e9 dans votre liste d\u2019envies avec votre composition', exists: ' est d\u00e9j\u00e0 dans votre liste d\u2019envies et reste dans le panier.',
          view: 'Voir la liste d\u2019envies', item: 'Article', changedMoved: 'Ajout\u00e9 \u00e0 votre liste d\u2019envies. Votre panier a chang\u00e9 entre-temps \u2013 veuillez le v\u00e9rifier.',
          changedMovedShort: 'Ajout\u00e9 \u00e0 votre liste d\u2019envies \u2013 votre panier a chang\u00e9 entre-temps.', failed: 'D\u00e9sol\u00e9, cela n\u2019a pas fonctionn\u00e9 \u2013 veuillez r\u00e9essayer.',
          changed: 'Votre panier a chang\u00e9 entre-temps \u2013 veuillez le v\u00e9rifier.' },
    it: { later: 'Per dopo', laterTitle: 'Salva nella lista dei desideri per dopo', moved: ' \u00e8 stato spostato nella tua lista dei desideri',
          movedCfg: ' \u00e8 stato spostato nella tua lista dei desideri con la tua composizione', exists: ' \u00e8 gi\u00e0 nella tua lista dei desideri e resta nel carrello.',
          view: 'Vedi lista dei desideri', item: 'Articolo', changedMoved: 'Aggiunto alla lista dei desideri. Nel frattempo il carrello \u00e8 cambiato \u2013 controllalo.',
          changedMovedShort: 'Aggiunto alla lista dei desideri \u2013 nel frattempo il carrello \u00e8 cambiato.', failed: 'Purtroppo non ha funzionato \u2013 riprova.',
          changed: 'Nel frattempo il carrello \u00e8 cambiato \u2013 controllalo.' },
    es: { later: 'Para despu\u00e9s', laterTitle: 'Guardar en tu lista de deseos para despu\u00e9s', moved: ' se ha movido a tu lista de deseos',
          movedCfg: ' se ha movido a tu lista de deseos con tu composici\u00f3n', exists: ' ya est\u00e1 en tu lista de deseos y sigue en el carrito.',
          view: 'Ver lista de deseos', item: 'Art\u00edculo', changedMoved: 'A\u00f1adido a tu lista de deseos. Tu carrito cambi\u00f3 mientras tanto \u2013 rev\u00edsalo.',
          changedMovedShort: 'A\u00f1adido a tu lista de deseos \u2013 tu carrito cambi\u00f3 mientras tanto.', failed: 'Lo sentimos, no ha funcionado \u2013 int\u00e9ntalo de nuevo.',
          changed: 'Tu carrito cambi\u00f3 mientras tanto \u2013 rev\u00edsalo.' }
  }[LANG] || null;
  var SNAP_SYNC_MAX_MS = 6500;   // Snap zieht ~4 s nach einer AJAX-Aenderung nach
  var SNAP_SYNC_GRACE_MS = 1200; // wenn kein Stufenwechsel zu erwarten ist
  var SNAP_POLL_MS = 600;

  function esc(s) { var d = document.createElement('div'); d.appendChild(document.createTextNode(s || '')); return d.innerHTML; }

  function toast(html, isError) {
    var t = document.createElement('div');
    t.className = 'lqp-wl-toast' + (isError ? ' lqp-wl-toast--error' : '');
    t.setAttribute('role', 'status');
    t.innerHTML = html;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-visible'); });
    setTimeout(function () { t.classList.remove('is-visible'); setTimeout(function () { t.remove(); }, 400); }, 6000);
  }

  function movedToast(title, withConfig) {
    if (TX) { toast(HEART + '&nbsp;<span><strong>' + esc(title) + '</strong>' + (withConfig ? TX.movedCfg : TX.moved) + '. <a href="' + WISHLIST_URL + '">' + TX.view + '</a></span>'); return; }
    toast(HEART + '&nbsp;<span><strong>' + esc(title) + '</strong> wurde ' + (withConfig ? 'mit deiner Zusammenstellung ' : '') + 'auf die Wunschliste verschoben. <a href="' + WISHLIST_URL + '">Wunschliste ansehen</a></span>');
  }

  function existsToast(title) {
    if (TX) { toast(HEART + '&nbsp;<span><strong>' + esc(title) + '</strong>' + TX.exists + ' <a href="' + WISHLIST_URL + '">' + TX.view + '</a></span>'); return; }
    toast(HEART + '&nbsp;<span><strong>' + esc(title) + '</strong> ist schon auf deiner Wunschliste und bleibt im Warenkorb. <a href="' + WISHLIST_URL + '">Wunschliste ansehen</a></span>');
  }

  function ss(key, value) { try { if (value === null) sessionStorage.removeItem(key); else sessionStorage.setItem(key, value); } catch (e) {} }
  function ssGet(key) { try { return sessionStorage.getItem(key); } catch (e) { return null; } }

  // Nach Seiten-Reload: Bestaetigung / Hinweis zeigen
  (function () {
    var moved = ssGet('lqpWlMoved');
    if (moved) { ss('lqpWlMoved', null); var cfg = ssGet('lqpWlMovedCfg') === '1'; ss('lqpWlMovedCfg', null); movedToast(moved, cfg); }
    var hint = ssGet('lqpWlHint');
    if (hint) { ss('lqpWlHint', null); toast(esc(hint), true); }
  })();

  // ---------------------------------------------------------- Cart-Helfer
  function cartJson() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart.js ' + r.status); return r.json(); });
  }
  function discountValue(cart) {
    var apps = (cart && cart.cart_level_discount_applications) || [];
    return apps.length ? String(apps[0].value) : '0';
  }
  function tierOf(subtotalCents) {
    var t = 0;
    for (var i = 0; i < SNAP_TIERS.length; i++) { if (subtotalCents >= SNAP_TIERS[i] * 100) t = i + 1; }
    return t;
  }
  function keyFromHref(href) {
    var m = /[?&]id=([^&#]+)/.exec(href || '');
    return m ? decodeURIComponent(m[1]) : null;
  }

  // Wartet nach einer AJAX-Mutation auf Snaps Nachzug (Rabattwert aendert sich). Loest mit true
  // (geaendert) oder false (Zeit um) auf – wirft nie.
  function waitForSnapSync(prevValue, expectChange) {
    var start = Date.now();
    var maxMs = expectChange ? SNAP_SYNC_MAX_MS : SNAP_SYNC_GRACE_MS;
    return new Promise(function (resolve) {
      (function tick() {
        if (Date.now() - start >= maxMs) return resolve(false);
        cartJson().then(function (c) {
          if (discountValue(c) !== prevValue) return resolve(true);
          setTimeout(tick, SNAP_POLL_MS);
        }, function () { setTimeout(tick, SNAP_POLL_MS); });
      })();
    });
  }

  // Zeile per Cart-API entfernen. waitSync=true: vor dem Aufloesen auf Snaps Nachzug warten
  // (vor einem Reload noetig, sonst wird der Nachzug abgebrochen). Fehler: err.code 'line-missing'
  // (veralteter Schluessel) oder 'http'.
  function removeLineAjax(lineKey, waitSync) {
    return cartJson().then(function (before) {
      var line = null;
      for (var i = 0; i < (before.items || []).length; i++) { if (before.items[i].key === lineKey) { line = before.items[i]; break; } }
      if (!line) { var e = new Error('line-missing'); e.code = 'line-missing'; throw e; }
      var prevValue = discountValue(before);
      var subBefore = before.items_subtotal_price || 0;
      var expectChange = tierOf(subBefore) !== tierOf(subBefore - (line.original_line_price || 0));
      return fetch('/cart/change.js', { method: 'POST', headers: JH, body: JSON.stringify({ id: lineKey, quantity: 0 }) })
        .then(function (r) {
          if (!r.ok) { var e2 = new Error('change ' + r.status); e2.code = (r.status === 404 || r.status === 422) ? 'line-missing' : 'http'; throw e2; }
          return waitSync ? waitForSnapSync(prevValue, expectChange) : false;
        });
    });
  }

  function onCartPage() { return window.location.pathname === CART_URL; }

  // ---------------------------------------------------------- Properties der Warenkorbzeile holen
  // Objekt Name -> Wert (leere Werte weggelassen) oder null. Schlaegt /cart.js fehl, wird
  // ABGEBROCHEN (Reject) – lieber gar nicht verschieben als eine Konfiguration stillschweigend verlieren.
  function lineProperties(lineKey) {
    if (!lineKey) return Promise.resolve(null);
    return cartJson().then(function (cart) {
      var items = (cart && cart.items) || [];
      for (var i = 0; i < items.length; i++) {
        if (items[i].key !== lineKey) continue;
        var src = items[i].properties || {};
        var out = {}, n = 0;
        for (var k in src) {
          if (!Object.prototype.hasOwnProperty.call(src, k)) continue;
          var v = src[k];
          if (v === null || v === undefined || String(v) === '') continue;
          out[k] = String(v);
          n++;
        }
        return n ? out : null;
      }
      return null; // Zeile nicht (mehr) im Warenkorb – ohne Properties weiter
    });
  }

  // ---------------------------------------------------------- Wunschlisten-Knopf (beide Oberflaechen)
  document.addEventListener('click', function (ev) {
    var btn = (ev.target && ev.target.closest) ? ev.target.closest('.lqp-move-to-wishlist') : null;
    if (!btn) return;
    ev.preventDefault();
    ev.stopPropagation();
    if (btn.hasAttribute('data-guest')) {
      window.location.href = CFG.loginUrl + '?return_url=' + encodeURIComponent(window.location.pathname);
      return;
    }
    if (btn.hasAttribute('disabled')) return;
    btn.setAttribute('disabled', 'disabled');

    var title = btn.getAttribute('data-product-title') || (TX ? TX.item : 'Artikel');
    var lineKey = btn.getAttribute('data-line-key');
    var isDrawer = btn.classList.contains('lqp-mtw-mini');
    var withConfig = false;

    lineProperties(lineKey)
      .then(function (props) {
        var body = new FormData();
        body.append('productId', btn.getAttribute('data-product-id'));
        body.append('variantId', btn.getAttribute('data-variant-id'));
        if (props) {
          withConfig = true;
          body.append('properties', JSON.stringify(props));
        }
        return fetch(API, { method: 'POST', body: body });
      })
      .then(function (res) {
        if (res.status === 401) {
          window.location.href = CFG.loginUrl + '?return_url=' + encodeURIComponent(window.location.pathname);
          throw new Error('login');
        }
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json().catch(function () { return {}; });
      })
      .then(function (data) {
        if (data && data.action === 'already_exists') {
          // Schon auf der Wunschliste: Warenkorbzeile behalten, nur Hinweis
          btn.removeAttribute('disabled');
          existsToast(title);
          return;
        }
        var row = btn.closest('tr.cart-item, .new-cart-item-product-card');
        var rm = row ? row.querySelector('a.remove-link') : null;
        if (!isDrawer && rm && rm.hasAttribute('data-lqp-bracelet-key')) {
          // Angepasstes Armband (Wunschgroesse): Interceptor nimmt den 2,99-€-Aufpreis atomar mit
          ss('lqpWlMoved', title); ss('lqpWlMovedCfg', withConfig ? '1' : '0');
          rm.click();
          return;
        }
        var key = lineKey || (rm ? keyFromHref(rm.getAttribute('href')) : null);
        if (!key) {
          // Altes Markup ohne Zeilen-Schluessel: bisheriger Weg
          ss('lqpWlMoved', title); ss('lqpWlMovedCfg', withConfig ? '1' : '0');
          if (rm) { rm.click(); } else { window.location.href = btn.getAttribute('data-remove-url'); }
          return;
        }
        var reload = onCartPage();
        return removeLineAjax(key, reload).then(function () {
          if (reload) { ss('lqpWlMoved', title); ss('lqpWlMovedCfg', withConfig ? '1' : '0'); window.location.reload(); }
          else { movedToast(title, withConfig); }
        }, function (err) {
          if (err && err.code === 'line-missing') {
            // Auf die Wunschliste ist der Artikel gekommen; die Zeile war schon weg/ersetzt
            ss('lqpWlHint', TX ? TX.changedMoved : 'Auf die Wunschliste gesetzt. Der Warenkorb hatte sich zwischenzeitlich geändert – bitte prüfen.');
            if (reload) { window.location.reload(); } else { btn.removeAttribute('disabled'); toast(TX ? TX.changedMovedShort : 'Auf die Wunschliste gesetzt – der Warenkorb hatte sich zwischenzeitlich geändert.', true); }
            return;
          }
          throw err;
        });
      })
      .catch(function (err) {
        if (err && err.message === 'login') return;
        btn.removeAttribute('disabled');
        toast(TX ? TX.failed : 'Das hat leider nicht geklappt – bitte nochmal versuchen.', true);
      });
  });

  // ---------------------------------------------------------- "Entfernen"-Links der Warenkorb-Seite -> AJAX
  // Angepasste Armbaender ([data-lqp-bracelet-key]) behandelt der Capture-Interceptor aus
  // armband-note-reconcile (stopImmediatePropagation) – die kommen hier nie an.
  document.addEventListener('click', function (ev) {
    var link = (ev.target && ev.target.closest) ? ev.target.closest('a.remove-link') : null;
    if (!link || link.hasAttribute('data-lqp-bracelet-key')) return;
    var key = keyFromHref(link.getAttribute('href') || '');
    if (!key) return; // unbekanntes Format -> Theme macht normal weiter
    ev.preventDefault();
    ev.stopPropagation();
    if (link.__lqpBusy) return;
    link.__lqpBusy = true;
    var row = link.closest('tr.cart-item, .new-cart-item-product-card');
    if (row) { row.style.opacity = '.5'; row.style.pointerEvents = 'none'; }
    removeLineAjax(key, onCartPage()).then(function () {
      window.location.reload();
    }, function (err) {
      if (err && err.code === 'line-missing') {
        ss('lqpWlHint', TX ? TX.changed : 'Der Warenkorb hatte sich zwischenzeitlich geändert – bitte prüfen.');
        window.location.reload();
        return;
      }
      window.location.href = link.getAttribute('href'); // Fallback: bisheriger Weg
    });
  });

  // ---------------------------------------------------------- Rabattstufe beim Aufruf der Warenkorb-Seite heilen
  function healSnapOnCartPage() {
    if (!onCartPage() || window.__lqpSnapHeal) return;
    window.__lqpSnapHeal = true;
    setTimeout(function () {
      cartJson().then(function (cart) {
        if (!cart.items || !cart.items.length) return;
        var prev = discountValue(cart);
        var line = cart.items[0];
        var loopKey = 'lqpSnapHealed:' + cart.token + ':' + cart.items_subtotal_price + ':' + prev;
        if (ssGet(loopKey)) return; // nach dem Heil-Reload nicht erneut
        // Same-Quantity-Change: fuer Shopify ein No-op, loest aber Snaps Nachzug der Rabattstufe aus
        return fetch('/cart/change.js', { method: 'POST', headers: JH, body: JSON.stringify({ id: line.key, quantity: line.quantity }) })
          .then(function (r) { if (!r.ok) return false; return waitForSnapSync(prev, true); })
          .then(function (changed) {
            if (!changed) return;
            ss(loopKey, '1');
            window.location.reload(); // Summen der Seite auf die korrigierte Stufe bringen
          });
      }).catch(function () {});
    }, 800);
  }
  healSnapOnCartPage();

  // ---------------------------------------------------------- Snap-Drawer-Injektion
  var SERVICE_VARIANT = '57448794227019';

  function decorateDrawer() {
    var drawer = document.getElementById('wizz4-cart-drawer');
    if (!drawer) return;
    var rows = drawer.querySelectorAll('.wizz-product-custom');
    if (!rows.length) return;
    var todo = [];
    for (var i = 0; i < rows.length; i++) {
      if (!rows[i].querySelector('.lqp-mtw-mini')) todo.push(rows[i]);
    }
    if (!todo.length) return;

    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var used = {};
      todo.forEach(function (rowWrap) {
        if (rowWrap.querySelector('.lqp-mtw-mini')) return;
        var link = rowWrap.querySelector('a[href*="/products/"]');
        if (!link) return;
        var m = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
        if (!m) return;
        var handle = m[1];
        var same = cart.items.filter(function (it) { return it.handle === handle; });
        var idx = used[handle] || 0;
        used[handle] = idx + 1;
        var item = same[idx] || same[0];
        if (!item) return;
        if (String(item.variant_id) === SERVICE_VARIANT) return;
        if ((item.product_title || '').indexOf('WhatsApp Bilderservice') > -1) return;

        var col = rowWrap.querySelector('div.w4-justify-between.w4-flex-col') || rowWrap;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'lqp-move-to-wishlist lqp-mtw-mini';
        b.setAttribute('data-product-id', item.product_id);
        b.setAttribute('data-variant-id', item.variant_id);
        b.setAttribute('data-line-key', item.key);
        b.setAttribute('data-product-title', item.product_title || '');
        if (!CFG.loggedIn) b.setAttribute('data-guest', '1');
        b.title = TX ? TX.laterTitle : 'Für später auf die Wunschliste';
        b.innerHTML = HEART + ' ' + (TX ? TX.later : 'Für später');
        col.appendChild(b);
      });
    }).catch(function () {});
  }

  var debounceTimer = null;
  function onMutate() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(decorateDrawer, 300);
  }
  try {
    new MutationObserver(onMutate).observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
  decorateDrawer();
})();
